"use strict";
import { Component, OnInit } from "@angular/core";
import { AwsService } from "../../providers/appsyncservice/aws.service";
import { Users } from "../../models/users";
import { identifierModuleUrl } from "@angular/compiler";
import * as XLSX from "xlsx";
import { first } from "rxjs/operators";
import { GoogleMapsAPIWrapper, MapsAPILoader } from "@agm/core";
import { Observable, empty } from "rxjs";
import { positions } from "../../models/positions";
declare var google: any;
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/map";
import { reject, async } from "q";
import { resolve } from "path";
import { AppConstants } from "../../constants/app-constants";
import { Response } from "@angular/http";
import { OtpService } from "../../service/otpservice/otp.service";
import { start } from "repl";
var CryptoJS = require("crypto-js");
//var	bar	= require('progress-bar').create(process.stdout);
@Component({
  selector: "app-uploadscreen",
  templateUrl: "./uploadscreen.component.html",
  styleUrls: ["./uploadscreen.component.css"],
})
export class UploadscreenComponent implements OnInit {
  displayValue: number = 0;
  arrayBuffer: any;
  file: File;
  copyFrom: String;
  copyTo: String;
  copyTrips: any;
  statusList: any[] = [];
  cnt: number = 1;
  copyCount: number = 0;
  uploadList: any[] = [];
  sheetlength: number = 0;
  progresspercent: number = 0;
  uploadStatus: Number;
  sheetinput: any = [];
  defaultPassword: String;
  officelat: number = 12.737471;
  officelong: number = 80.006029;
  dateSplitArray: any = [];
  delay = (ms) => new Promise((res) => setTimeout(res, ms));

  constructor(
    public awserviceProvider: AwsService,
    public otpService: OtpService
  ) {}
  ngOnInit() {
    this.progresspercent = 0;
  }
  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    //alert( this.file)
  }
  //On Clikc Upload Event
  uploadtrip() {
    if (this.file == undefined) {
      this.uploadStatus = 0;
      return;
    }
    this.progresspercent = 0;
    this.uploadList = [];
    this.uploadStatus = 1;
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      //alert("inside");
      // this.uploadStatus = 1;
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      console.log("first_sheet_name", first_sheet_name);
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.log("first_sheet_name", sheet);
      this.sheetlength = sheet.length;
      this.startProcess(sheet);
    };
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record
  async startProcess(sheet) {
    // bar.update(0.5);
    console.log("FULL", sheet);
    for (const dict of sheet) {
      var scheduled_date = String(dict["scheduled_date"]).trim();
      var start_address = String(dict["home_address"]).trim();
      var end_address = String(dict["office_address"]).trim();
      var role = String(dict["role"]).toLowerCase().trim();
      var drop_point = Number(dict["drop_point"]);
      var vehicle_no = String(dict["vehicle_no"]).trim();
      var phone_no = String(dict["phone_no"]).trim();
      var trip_type =
        String(dict["trip_type"]).toUpperCase() === "D" ? "1" : "0";
      var user_id = String(dict["user_id"]).toUpperCase().trim();
      var user_name = String(dict["user_name"]).toUpperCase().trim();
      var driver_id = String(dict["driver_id"]).trim();
      var emergency_phone_no = String(dict["emergency_phone_no"]).trim();
      var vehicle_model = String(dict["vehicle_model"]).trim();
      var is_guest = Number(dict["is_guest"]);
      var g_lat = Number(dict["lat"]);
      var g_lng = Number(dict["lng"]);
      var o_lat = Number(dict["office_lat"]);
      var o_lng = Number(dict["office_lng"]);
      var notification_flag = Number(dict["notification_flag"]);
      var agency_type = String(dict["agency_type"]).trim();
      var driver_type = String(dict["driver_type"]).trim();
      let users: any = {};
      users.driver_id = driver_id;
      users.vehicle_model = vehicle_model == "" ? "-" : vehicle_model;
      users.scheduled_date = scheduled_date; // + "+05:30";
      users.drop_point = drop_point;
      users.vehicle_no = vehicle_no;
      users.trip_type = trip_type;
      users.user_id = user_id;
      users.name = user_name;
      users.is_guest = is_guest;
      users.notification_flag = notification_flag;
      users.agency_type = agency_type;
      users.driver_type = driver_type;
      users.gstart = start_address;
      users.gend = end_address;
      users.start = {};
      users.end = {};
      var stringDateObject = users.scheduled_date; // '2020-4-3T2:00:54'
      console.log("stringDateObject", stringDateObject);
      this.dateSplitArray = stringDateObject.split("T");
      var dateObj = new Date(this.dateSplitArray);
      var scheduledDateObj =
        dateObj.getFullYear() +
        "-" +
        (dateObj.getMonth() + 1 < 10 ? "0" : "") +
        (dateObj.getMonth() + 1) +
        "-" +
        ((dateObj.getDate() < 10 ? "0" : "") +
          dateObj.getDate() +
          "T" +
          ((dateObj.getHours() < 10 ? "0" : "") + dateObj.getHours()) +
          ":" +
          ((dateObj.getMinutes() < 10 ? "0" : "") + dateObj.getMinutes()) +
          ":" +
          ((dateObj.getSeconds() < 10 ? "0" : "") + dateObj.getSeconds()));
      console.log("today", scheduledDateObj);
      var sign = dateObj.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(dateObj.getTimezoneOffset());
      var hours = Math.floor(offset / 60);
      const hoursleadingZero = (hours < 10 ? "0" : "") + hours;
      var minutes = offset % 60;
      var minutesleadingZero = (minutes < 10 ? "0" : "") + minutes;
      var timeZone = sign + hoursleadingZero + ":" + minutesleadingZero;
      users.scheduled_date = scheduledDateObj + timeZone; // '2020-04-03T02:00:54+05:30'
      console.log("::::::::::::::::TimeDB", users.scheduled_date);

      if (users.trip_type == 0) {
        users.end.lat = this.officelat;
        users.end.long = this.officelong;
        users.end.address = "RNTBCI";
      } else {
        users.start.lat = this.officelat;
        users.start.long = this.officelong;
        users.start.address = "RNTBCI";
      }

      if (g_lat != 0 && g_lng != 0) {
        users.is_coordinate = true;
      }
      // if (is_guest == 1) {
      users.guesthome = {};
      users.guesthome.lat = g_lat;
      users.guesthome.long = g_lng;

      users.guestoffice = {};
      users.guestoffice.lat = o_lat;
      users.guestoffice.long = o_lng;

      // }
      users.password = CryptoJS.AES.encrypt(
        AppConstants.defaultPassword,
        AppConstants.cryptoKey
      ).toString();
      users.user_type = (
        role === "driver" ? 2 : role === "personal driver" ? 3 : 1
      ).toString();
      users.employee_phone =
        phone_no != "undefined" ? "+91" + phone_no.trim() : "-";
      users.emergency_phone =
        emergency_phone_no != "undefined"
          ? "+91" + emergency_phone_no.trim()
          : "-";
      if (
        emergency_phone_no.trim().length != 10 ||
        phone_no.trim().length != 10
      ) {
        this.displayValue = 1;
        this.statusList.push({
          line_no: this.cnt,
          status: AppConstants.Warning,
          error: AppConstants.PhoneNumberError,
        });
      }

      users.home_address =
        start_address === "undefined" || start_address == "-"
          ? "-"
          : start_address;
      users.office_address =
        end_address === "undefined" || end_address == "-" ? "-" : end_address;

      if (users.home_address != "-") {
        users.updatehome = true;
      }

      if (
        (user_id.substring(0, 1) != "R" && user_id.length != 10) ||
        (user_id.substring(0, 1) == "R" && user_id.length < 7)
      ) {
        this.displayValue = 1;
        this.progressIncrement();
        this.statusList.push({
          line_no: this.cnt,
          status: AppConstants.Error,
          error: AppConstants.InvalidRNNumber,
        });
      } else {
        await this.createRncUser(users);
      }
    }
  }

  async getGeoLocation(address: string): Promise<any> {
    // console.log('address', address)
    let myPromise = await new Promise((resolve, reject) => {
      setTimeout(() => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            // // // console.log("lat", lat)
            // // // console.log("lat", lng)
            var pos = new positions();
            pos.latitude = lat;
            pos.longitude = lng;
            resolve(pos);
            // console.log('GeoLocation found')
          } else {
            // console.log("geo locaton status error--", status, results)
            reject(status);
          }
        });
      }, 2300);
    });
    return myPromise;
  }
  async updateLocation(user) {
    // console.log("2", user)

    await this.getGeoLocation(user.home_address)
      .then(async (st) => {
        // console.log("LOCATION FOUND", st)
        user.hlat = st.latitude;
        user.hlong = st.longitude;
        await this.awserviceProvider
          .updateRncUserLocation(
            user.id,
            st.latitude,
            st.longitude,
            user.home_address
          )
          .then(async (res) => {
            // console.log("UPDATING LOCATION", res)
            return user;
          })
          .catch((err) => {
            // console.log("ERROR UPDATING", err)
          });
      })
      .catch((err) => {
        // console.log("ERROR GETTING LOCATION------------------", err)
      });
    // console.log("3", user)
    // return user;
  }

  async findAndUpdateLocation(user) {
    if (user.updatehome) {
      this.updateLocation(user)
        .then((res) => {
          // console.log("^^^^^^^^", user)
          user = res;
          return user;
        })
        .catch((err) => {
          this.displayValue = 1;
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Warning,
            error: AppConstants.UserCreationFailed,
          });
        });
      return user;
    }
  }

  //Check user is exists or not
  // If Exists update name,phone number
  // CHeck LOcation update
  async createRncUser(user) {
    if (user.is_guest != 1) {
      console.log("user_id", user.user_id);
      await this.awserviceProvider
        .findUserByUserName(user.user_id)
        .then(async (userid) => {
          if (userid.length == 0) {
            // User not available
            if (user.user_id.substring(0, 1) == "R") {
              // RN Employee not available in the DB
              this.displayValue = 1;
              this.progressIncrement();
              this.statusList.push({
                line_no: this.cnt,
                status: AppConstants.Error,
                error: AppConstants.NewRNNumber,
              });
            } else {
              // new Driver to be created
              await this.awserviceProvider
                .createRncUser(user)
                .then(async (usernew) => {
                  // create new user
                  user.id = usernew.id;
                  this.findAndUpdateLocation(user);
                  await this.createDriverUser(user); // update driver details
                })
                .catch((err) => {
                  this.displayValue = 1;
                  this.progressIncrement();
                  this.statusList.push({
                    line_no: this.cnt,
                    status: AppConstants.Error,
                    error: AppConstants.UserCreationFailed,
                  });
                });
            }
          } else {
            // User available
            user.id = userid[0].id;
            await this.awserviceProvider.updateRncUsersContact(user); // update User contact
            this.findAndUpdateLocation(user);
            await this.createDriverUser(user); // update driver details
          }
        });
    } else {
      user.id = user.user_id;
      this.findAndUpdateLocation(user);
      await this.createDriverUser(user);
    }
  }

  async createDriverUser(user) {
    // console.log("USER ACC", user)
    await this.awserviceProvider
      .findUserByUserName(user.driver_id)
      .then(async (driver) => {
        if (driver.length == 0) {
          // this.progressIncrement();
          this.displayValue = 1;
          this.progressIncrement();
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Error,
            error: AppConstants.DriverNotAvailable,
          });
        } else {
          user.driverid = driver[0].id;
          user.drivername = driver[0].name;
          user.drivertype = driver[0].user_type;
          console.log("user.drivertype: ", user.drivertype);
          if (user.drivertype != 3) {
            await this.createScCabMaster(user);
          } else {
            await this.createDaVehicleMaster(user);
          }
        }
      });
  }
  async createScCabMaster(user) {
    await this.awserviceProvider
      .getScCabMaster(user.driverid, user.vehicle_no)
      .then(async (cabid) => {
        if (cabid.length == 0) {
          await this.awserviceProvider
            .createScCabMaster(user.driverid, user.drivername, user.vehicle_no)
            .then(async (cabnew) => {
              user.cab_id = cabnew.id;
              await this.createScTripMaster(user);
            })
            .catch((err) => {
              this.displayValue = 1;
              this.progressIncrement();
              this.statusList.push({
                line_no: this.cnt,
                status: AppConstants.Error,
                error: AppConstants.CabCreationFailed,
              });
            });
        } else {
          user.cab_id = cabid[0].id;
          await this.createScTripMaster(user);
        }
      });
  }
  async createScTripMaster(user) {
    await this.awserviceProvider
      .getScTripMaster(
        user.driverid,
        user.cab_id,
        user.trip_type,
        user.scheduled_date
      )
      .then(async (trip) => {
        console.log("getScUserTrip ", trip);

        if (trip.length == 0) {
          await this.awserviceProvider
            .createScTripMaster(
              user.driverid,
              user.cab_id,
              user.trip_type,
              user.scheduled_date
            )
            .then(async (tripnew) => {
              user.trip_id = tripnew.id;

              await this.delay(5000);

              await this.createScUserTrip(user);
            })
            .catch((err) => {
              this.displayValue = 1;
              this.progressIncrement();
              console.log("createScTripMaster", err);
              this.statusList.push({
                line_no: this.cnt,
                status: AppConstants.Error,
                error: AppConstants.TripCreationFailed,
              });
            });
        } else {
          user.trip_id = trip[0].id;
          await this.createScUserTrip(user);
        }
      });
  }

  async createScUserTrip(user) {
    console.log("getScUserTripUserId", user);
    await this.awserviceProvider
      .getScUserTripUserId(user.trip_id, user.id, user.scheduled_date)
      .then(async (res) => {
        console.log("getScUserTripUserId", res);
        let sctrip: any = res;
        if (sctrip.length == 0) {
          user.scusertripid = "";
          await this.updateScUserTripAddress(user);
        } else {
          user.scusertripid = sctrip[0].id;
          await this.updateScUserTripAddress(user);
        }
      });
  }

  async updateScUserTripAddress(user) {
    user.position = {};
    console.log("USER_ADDRESS", user.id);
    this.awserviceProvider
      .getRncUsersLocation(user.id)
      .then(async (res) => {
        console.log("USER_ADDRESS", res);
        if (res.home_address != null) {
          if (res.home_address.lat <= 0 || res.home_address.long <= 0) {
            this.uploadError(user);
          }
          if (user.trip_type == 0) {
            user.start = res.home_address;
            user.start.address = res.home_address.address;
          } else {
            user.end = res.home_address;
            user.end.address = res.home_address.address;
          }

          await this.createScUserTripMaster(user);
        } else {
          this.uploadError(user);
          await this.createScUserTripMaster(user);
          this.displayValue = 1;
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Warning,
            error: AppConstants.UserTripAddressUpdateFailed,
          });
        }
      })
      .catch((err) => {
        console.log("UserTripCreationFailed", err);
        this.progressIncrement();
        this.uploadError(user);
        this.displayValue = 1;
        this.statusList.push({
          line_no: this.cnt,
          status: AppConstants.Error,
          error: AppConstants.UserTripCreationFailed,
        });
      });
  }

  async createScUserTripMaster(user) {
    console.log("1update", user);
    console.log("ser.scusertripid", user.scusertripid);
    console.log("ser.scusertripid", user.scusertripid == "");
    if (user.scusertripid == "") {
      this.awserviceProvider
        .createScUserTrip(
          user.trip_id,
          user.id,
          user.trip_type,
          user.drop_point,
          user.scheduled_date,
          user.start,
          user.end
        )
        .then((res) => {
          this.progressIncrement();
        })
        .catch((err) => {
          console.log("ERR", err);
        });
    } else {
      this.awserviceProvider
        .updateScUserTrip(user.scusertripid, user.start, user.end)
        .then((res) => {
          this.progressIncrement();
        })
        .catch((err) => {
          this.progressIncrement();
          this.displayValue = 1;
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Warning,
            error: AppConstants.UserTripAddressUpdateFailed,
          });
        });
    }
  }

  async createDaVehicleMaster(user) {
    console.log("-----> inside createDaVehicleMaster");
    console.log("user.id: " + user.id);
    if (user.driver_id != user.user_id) {
      await this.awserviceProvider
        .getVehicleMasterByUser(user.id)
        .then(async (vhclmst) => {
          console.log("-----> getVehicleMasterByUser: vhclmst: ");
          console.log(vhclmst);
          var isUpdate = false;
          if (vhclmst.length > 0) {
            for (var k = 0; k < vhclmst.length; k++) {
              var element = vhclmst[k];
              if (user.driver_type == element.driver_type) {
                console.log("-----> update Vehicle Master");
                user.vehiclemstid = vhclmst[k].id;
                this.saveVehicleMaster(user, 2);
                isUpdate = true;
                break;
              }
            }
          }
          if (!isUpdate) {
            console.log("-----> create new Vehicle Master");
            this.saveVehicleMaster(user, 1);
          }
          /*
        if (vhclmst.length == 0) {
          console.log("-----> create new Vehicle Master")
          this.saveVehicleMaster(user, 1);
        }
        else {
          console.log("-----> update Vehicle Master")
          user.vehiclemstid = vhclmst[0].id;
          this.saveVehicleMaster(user, 2);
        }
        */
        });
    } else {
      this.progressIncrement();
      return;
    }
  }

  async saveVehicleMaster(user, flag) {
    // console.log("saveVehicleMaster")

    let vehiclefm: any = {};

    vehiclefm.driver_id = user.driverid;
    vehiclefm.vehicle_no = user.vehicle_no;
    vehiclefm.user_id = user.id;
    vehiclefm.user_name = user.name;
    vehiclefm.status = 0;
    vehiclefm.vehicle_model = user.vehicle_model;
    vehiclefm.geofence_limit = 500;
    vehiclefm.home_address = user.gstart;
    vehiclefm.office_address = user.gend;
    vehiclefm.user_phone_number = user.employee_phone;
    vehiclefm.home_lat = user.guesthome.lat;
    vehiclefm.home_long = user.guesthome.long;
    vehiclefm.office_lat = user.guestoffice.lat;
    vehiclefm.office_long = user.guestoffice.long;
    vehiclefm.notification_flag = user.notification_flag;
    vehiclefm.agency_type = user.agency_type;
    vehiclefm.driver_type = user.driver_type;

    this.awserviceProvider.updatePersonalDriverAgency(
      user.driverid,
      user.agency_type
    );

    // console.log("vehiclefm", vehiclefm)

    if (user.is_coordinates) {
      await this.getGeoLocation(user.startAddress.address)
        .then(async (home) => {
          let homeposition: any = {};
          homeposition.lat = home.latitude;
          homeposition.long = home.longitude;

          await this.getGeoLocation(user.endAddress.address)
            .then(async (office) => {
              let officeposition: any = {};
              officeposition.lat = office.latitude;
              officeposition.long = office.longitude;

              this.vehiclemaster(
                user,
                flag,
                vehiclefm,
                homeposition,
                officeposition
              );
            })
            .catch((err) => {
              this.progressIncrement();
              this.displayValue = 1;
              this.statusList.push({
                line_no: this.cnt,
                status: AppConstants.Error,
                error: AppConstants.AddressNotFound,
              });
            });
        })
        .catch((err) => {
          this.progressIncrement();
          this.displayValue = 1;
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Error,
            error: AppConstants.AddressNotFound,
          });
        });
    } else {
      this.vehiclemaster(
        user,
        flag,
        vehiclefm,
        user.guesthome,
        user.guestoffice
      );
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }
    //  // console.log("progresspercent",   Math.round(this.cnt * 100 / this.sheetlength)    );
    this.progresspercent = (this.cnt * 100) / this.sheetlength;
    this.cnt++;
  }

  vehiclemaster(user, flag, vehiclefm, homeposition, officeposition) {
    // console.log("vehiclemaster")

    if (flag == 1) {
      // this.awserviceProvider.createVehicleMst(vehiclefm, homeposition, officeposition).then(res => {
      this.awserviceProvider
        .createVehicleMst(vehiclefm)
        .then((res) => {
          this.progressIncrement();
          // console.log("res", res)
        })
        .catch((err) => {
          this.progressIncrement();
          console.log("VehicleMasterError1", err);
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Error,
            error: AppConstants.VehicleMasterUserExists,
          });
          // console.log("err", err)
        });
    } else {
      vehiclefm.id = user.vehiclemstid;
      // this.awserviceProvider.updateVehicleMaster(vehiclefm, homeposition, officeposition).then(res => {
      this.awserviceProvider
        .updateVehicleMaster(vehiclefm)
        .then((res) => {
          this.progressIncrement();
          //this.statusList.push({line_no: this.cnt, status : AppConstants.Error, error : AppConstants.VehicleMasterError})
        })
        .catch((err) => {
          this.progressIncrement();
          this.displayValue = 1;
          console.log("VehicleMasterError2", err);
          this.statusList.push({
            line_no: this.cnt,
            status: AppConstants.Error,
            error: AppConstants.VehicleMasterError,
          });
        });
    }
  }

  nextTokenTrip(token) {
    this.awserviceProvider
      .getScTripMasterByDateWithToken(this.copyFrom, token)
      .then((masterTrip: any) => {
        if (masterTrip.nextToken != null) {
          this.nextTokenTrip(masterTrip.nextToken);
        }
        masterTrip.items.forEach((trip) => {
          this.copyTrips.push(trip);
        });
      });
  }

  copyTrip() {
    let count = 0;

    if (
      this.copyFrom == undefined ||
      this.copyTo == undefined ||
      this.copyFrom == this.copyTo
    ) {
      return;
    }
    this.copyTrips = [];
    this.awserviceProvider
      .getScTripMasterByDate(this.copyFrom)
      .then((masterTrip: any) => {
        if (masterTrip.nextToken != null) {
          this.nextTokenTrip(masterTrip.nextToken);
        }
        masterTrip.items.forEach((trip) => {
          this.copyTrips.push(trip);
        });

        this.copyTrips.forEach((trip) => {
          this.CopyScTripMaster(trip);
          count++;
          this.copyCount = (count * 100) / this.copyTrips.length;
        });
      })
      .catch((err) => {});
  }

  async CopyScTripMaster(trip) {
    await this.awserviceProvider
      .getScTripMaster(
        trip.driver_id,
        trip.cab_id,
        trip.trip_type,
        trip.scheduled_date.replace(this.copyFrom, this.copyTo)
      )
      .then(async (tripmst) => {
        if (tripmst.length == 0) {
          this.awserviceProvider
            .createScTripMaster(
              trip.driver_id,
              trip.cab_id,
              trip.trip_type,
              trip.scheduled_date.replace(this.copyFrom, this.copyTo)
            )
            .then((tripId) => {
              this.getScUserTripMst(trip, tripId.id);
            })
            .catch((err) => {
              console.log("err", err);
            });
        } else {
          this.getScUserTripMst(trip, tripmst[0].id);
        }
      });
  }

  //get sc user trip by old trip Id and create new sc user trip
  getScUserTripMst(trip, newTripId) {
    this.awserviceProvider
      .getScUserTipByTripIdAllFields(trip.id)
      .then((usertrips: any) => {
        // console.log("02 usertrips", usertrips)
        usertrips.forEach((usertrip) => {
          this.checkUpdateScUserTrip(usertrip, newTripId);
        });
      })
      .catch((err) => {
        console.log("Error in getting ScUserTrip");
      });
  }

  async checkUpdateScUserTrip(trip, newTripId) {
    await this.awserviceProvider
      .getScUserTripUserId(
        newTripId,
        trip.user_id,
        trip.scheduled_date.replace(this.copyFrom, this.copyTo)
      )
      .then(async (res) => {
        let sctrip: any = res;
        if (sctrip.length == 0) {
          this.awserviceProvider
            .createScUserTrip(
              newTripId,
              trip.user_id,
              trip.trip_type,
              trip.drop_point,
              this.copyTo + trip.scheduled_date.substr(10),
              trip.start_address,
              trip.end_address
            )
            .then((id) => {})
            .catch((err) => {
              console.log("err", err);
            });
        }
        // else {
        //   this.awserviceProvider.UpdateScUserTripsOtp(sctrip[0].id).then(result => {
        //     console.log("update OTP to 123456")

        //     }).catch(err => {
        //       console.log("err", err)
        //     })

        // }
      });
  }

  updateOtp() {}

  exportToExcel() {
    let exportJsonTemp = [];

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.uploadList);
    // //console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book
    XLSX.writeFile(workBook, "SafeCab_Upload_Invalid_Address.xlsx");
  }

  uploadError(user) {
    let data: any = {};
    data.scheduled_date = user.scheduled_date;
    data.drop_point = user.drop_point;
    data.role = user.role;
    data.vehicle_no = user.vehicle_no;
    data.trip_type = user.trip_type;
    data.name = user.name;
    data.user_id = user.user_id;
    data.driver_id = user.driver_id;
    data.employee_phone = user.employee_phone;
    data.emergency_phone = user.emergency_phone;
    data.home_address = user.home_address;

    this.uploadList.push(data);
  }

  updateDaVehicleMaster() {
    this.awserviceProvider.getVehicleMaster().then((vehicleMs) => {
      let vhclMstLt = vehicleMs;

      vhclMstLt.forEach((element) => {
        if (element.office_address.address != "RNTBCI") {
          this.awserviceProvider
            .updateVehicleMasterlimit(element.id, 12.737693, 80.006663)
            .then((res) => {
              console.log("UPDATEDID", res);
            });
        } else {
          console.log("GEOFENCE", element.geofence_limit);
        }
      });
    });
  }

  migration() {
    if (this.file == undefined) {
      this.uploadStatus = 0;
      return;
    }
    this.progresspercent = 0;
    this.uploadList = [];
    this.uploadStatus = 1;
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      //alert("inside");
      // this.uploadStatus = 1;
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      console.log("first_sheet_name", first_sheet_name);
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.log("first_sheet_name", sheet);
      this.sheetlength = sheet.length;
      this.startFitnessAppMigration(sheet);
    };
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  async rncUserCorrection(sheet) {
    // bar.update(0.5);
    console.log("FULL", sheet);
    for (const dict of sheet) {
      var id = String(dict["id"]);
      var user_type = String(dict["user_type"]);
      this.awserviceProvider
        .updateRncUserType(id, parseInt(user_type))
        .then((res) => {
          console.log("UPDATEDID", res);
        });
    }
  }

  async startFitnessAppMigration(sheet) {
    // bar.update(0.5);
    console.log("FULL", sheet);
    for (const dict of sheet) {
      var rn_number = String(dict["rn_number"]);
      var rating = String(dict["rating"]);
      var remarks = String(dict["remarks"]);
      var timestamp = String(dict["timestamp"]);

      let trips: any = {};
      trips.rn_number = rn_number;
      trips.remarks = remarks;
      trips.timestamp = timestamp;
      trips.rating = parseInt(rating);

      console.log("TRIPS", trips);
      this.awserviceProvider.createProdAppFitnessFeedback(trips).then((res) => {
        console.log("UPDATEDID", res);
      });
    }
  }

  async startMigrationProcess(sheet) {
    // bar.update(0.5);
    console.log("FULL", sheet);
    for (const dict of sheet) {
      var created_at = String(dict["created_at"]);
      var driver_id = String(dict["driver_id"]);
      var duty_start_address = String(dict["duty_start_address"]);
      var duty_start_date = String(dict["duty_start_date"]);
      var duty_end_address = String(dict["duty_end_address"]);
      var duty_end_date = String(dict["duty_end_date"]);
      var trip_status = String(dict["trip_status"]);
      var trip_type = String(dict["trip_type"]);
      var vehicle_no = String(dict["vehicle_no"]);

      let trips: any = {};
      trips.created_at = created_at;
      trips.driver_id = driver_id;
      trips.duty_start_address = duty_start_address;
      trips.duty_start_date = duty_start_date;
      trips.duty_end_address = duty_end_address;
      trips.duty_end_date = duty_end_date;
      trips.trip_type = trip_type;
      trips.vehicle_no = vehicle_no;
      trips.trip_status = parseInt(trip_status);

      console.log("TRIPS", trips);
      this.awserviceProvider.createProdDaTrips(trips).then((res) => {
        console.log("UPDATEDID", res);
      });
    }
  }

  uploadHrPolicyData() {
    this.awserviceProvider
      .createRnHrbotKeymapsSuggestions(
        "context_key",
        ["context_query_val"],
        ["context_suggestions"],
        "policy_names"
      )
      .then((res) => {
        console.log("createRnHrbotKeymapsSuggestions", res);
      });
  }
}

// this.otpService.SendSMS(usertrip.id).pipe(first()).subscribe( data =>{
//   // this.upasscode = data;
//   // console.log("SOS",data)
//   });
